import React from 'react';
import { Pagination } from 'semantic-ui-react';
import { FlexCard, PageSizeSelect } from '..';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import styled from 'styled-components';

export const PaginationRow = ({
  activePage,
  onPageChanged,
  onPageSizeChanged,
  pageSelectTitle,
  pageSize,
  totalItems,
  location = 'both',
  exportButton: {
    visible = false,
    fileName = 'SimulcastDataExport',
    sheetName = 'Export',
    showLocation = ['top', 'bottom'],
    buttonText = 'Export to Excel',
  } = {},
  children,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  return (
    <FlexCard
      data-testid="pagination-container"
      verticalAlignment="center"
      horizontalAlignment="space-between"
    >
      <FlexCard verticalAlignment="center" horizontalAlignment="flex-start">
        <PaginationRangeLabel
          activePage={activePage}
          pageSize={pageSize}
          totalItems={totalItems}
        />
        {children}
      </FlexCard>
      <FlexCard
        verticalAlignment="center"
        style={{ padding: '5px', height: '100%' }}
      >
        <PageSizeSelect
          pageSize={pageSize}
          totalItems={totalItems}
          onPageSizeChanged={onPageSizeChanged}
          title={pageSelectTitle}
        />
        <Pagination
          style={{ fontSize: '1em' }}
          activePage={activePage}
          totalPages={totalPages}
          onPageChange={onPageChanged}
        />
        {visible && showLocation.includes(location) && (
          <ExportButtonWrapper>
            <ReactHTMLTableToExcel
              data-testid="export-button"
              className="btn btn-info"
              table="table-to-xls"
              filename={fileName}
              sheet={sheetName}
              buttonText={buttonText}
            />
          </ExportButtonWrapper>
        )}
      </FlexCard>
    </FlexCard>
  );
};

export const PaginationRangeLabel = ({ activePage, pageSize, totalItems }) => {
  const firstPage = 1;
  const isFirstPage = activePage === firstPage;
  const haveMorePagesToView = pageSize < totalItems;
  const expectedRowsForPage = activePage * pageSize;
  const activePageRows =
    expectedRowsForPage > totalItems ? totalItems : expectedRowsForPage;
  const currentPageRows =
    activePage * haveMorePagesToView ? activePageRows : totalItems;
  const firstRowNumOfActivePage = pageSize * (activePage - 1) + 1;
  const lastRowNumOfPage =
    activePage * haveMorePagesToView ? currentPageRows : totalItems;

  // console.log('PaginationRangeLabel', { activePage, pageSize, totalItems, firstPage, isFirstPage, haveMorePagesToView, activePageRows, currentPageRows, firstRowNumOfActivePage, lastRowNumOfPage });

  return (
    <div>
      {`Showing ${
        isFirstPage ? firstPage : firstRowNumOfActivePage
      } - ${lastRowNumOfPage} of ${totalItems}`}
    </div>
  );
};

export const ExportButtonWrapper = styled(FlexCard)`
  margin-left: 10px;
  & .btn-info {
    color: #fff;
    background-color: #2185d0;
    border-color: #2185d0;
    padding: 4px 8px;
  }
`;
